import { useSelector } from "react-redux";

export const Loader = () =>{
    const {loading:isLoading, userinfo} = useSelector(state=>state)
    global.userInfo = userinfo;
    
    if(isLoading) {
        return (
            <div style={style.view}>
                <img src={'/images/loader.gif'} style={{height:100,width:100}} />
            </div>
        )
    } else {
        return null;
    }
}

const Loading = (value) =>{
    global.dispatch({type:'LOADING',payload:value});
}

global.Loader = Loading;

const style = {
    view:{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',      
        zIndex:99,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
    },
}